import type { TreeNodeData } from "../types";

export const walkTree = (
  nodes: TreeNodeData[],
  callback: (node: TreeNodeData) => void
): void => {
  nodes.forEach(node => {
    callback(node);
    if (node.children) walkTree(node.children, callback);
  });
};

export const findNode = (
  key: string,
  nodes: TreeNodeData[]
): TreeNodeData | undefined => {
  for (const node of nodes) {
    if (node.key === key) return node;
    if (node.children) {
      const found = findNode(key, node.children);
      if (found) return found;
    }
  }

  return undefined;
};

export const expandedKeysToOpenState = (
  keys: string[]
): Record<string, boolean> =>
  keys.reduce<Record<string, boolean>>((map, key) => {
    map[key] = true;

    return map;
  }, {});

export const getExpandedKeysFromTree = (
  rootChildren: { id: string; isOpen: boolean; children: unknown[] | null }[]
): string[] => {
  const keys: string[] = [];
  const walk = (
    nodes: { id: string; isOpen: boolean; children: unknown[] | null }[]
  ) => {
    nodes.forEach(node => {
      if (node.isOpen) keys.push(node.id);
      if (node.children) walk(node.children as typeof nodes);
    });
  };
  walk(rootChildren);

  return keys;
};

export const countAllNodes = (nodes: TreeNodeData[]): number => {
  let count = 0;
  walkTree(nodes, () => count++);

  return count;
};
